export default "__VITE_ASSET__DkeserdQ__"